import script from "./BioPage.vue?vue&type=script&setup=true&lang=js"
export * from "./BioPage.vue?vue&type=script&setup=true&lang=js"

import "./BioPage.vue?vue&type=style&index=0&id=1b9a7ac5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1b9a7ac5"]])

export default __exports__